import React from 'react';
import { Navigate } from 'react-router-dom';
import useUserData from 'hooks/useUserData';
import { AuthContext } from 'context/AuthContext';
import Loader from './loaderComponent';

const SuperAdminRoute = ({ children }) => {
    const { email, isInternal, isExternal, isAdmin } = React.useContext(AuthContext);
    const { isSuperAdmin, loading } = useUserData(email, isInternal, isExternal, isAdmin);

    if (loading) return <Loader />;

    if (!isSuperAdmin) {
        return <Navigate to="/error" replace />;
    }

    return children;
};

export default SuperAdminRoute; 